document.querySelector(".popup-btn")?.addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup").style.display = 'block';
       document.querySelector(".popup-close").previousElementSibling.src = "https://www.youtube.com/embed/iNuQCurkuUQ"
}, false);

document.querySelector(".popup-btn")?.addEventListener('click', function () {

  document.querySelector(".popup-overlay").style.display = 'block';
       document.querySelector(".popup-close").previousElementSibling.src = "https://www.youtube.com/embed/iNuQCurkuUQ"
  

}, false);

document.querySelector(".popup-close")?.addEventListener('click', function () {
    document.querySelector(".popup-close").previousElementSibling.src = ""
  document.querySelector(".popup").style.display = 'none';
  document.querySelector(".popup-overlay").style.display = 'none';
 
  
     


}, false);

document.querySelector("body")?.addEventListener('click', function () {
      document.querySelector(".popup-close").previousElementSibling.src = ""
  document.querySelector(".popup").style.display = 'none';
  document.querySelector(".popup-overlay").style.display = 'none';
}, false);

document.querySelector(".popup")?.addEventListener('click', function (e) {
  e.stopPropagation();
}, false);

// -------------
const popupDesc = document.querySelector(".popup-btn-desc");
if (popupDesc) {
  popupDesc?.addEventListener('click', function (e) {
    e.stopPropagation();
    document.querySelector(".popup-desc").style.display = 'block';
         //document.querySelector(".popup-close-desc").previousElementSibling.src = "https://www.youtube.com/embed/iNuQCurkuUQ"
  }, false);
  
  popupDesc?.addEventListener('click', function () {
  
    document.querySelector(".popup-overlay-desc").style.display = 'block';
      //   document.querySelector(".popup-close-desc").previousElementSibling.src = "https://www.youtube.com/embed/iNuQCurkuUQ"
    
  
  }, false);
  
  document.querySelector(".popup-close-desc")?.addEventListener('click', function () {
      document.querySelector(".popup-close-desc").previousElementSibling.src = ""
    document.querySelector(".popup-desc").style.display = 'none';
    document.querySelector(".popup-overlay-desc").style.display = 'none';
   
    
       
  
  
  }, false);
  
  document.querySelector("body")?.addEventListener('click', function () {
        document.querySelector(".popup-close-desc").previousElementSibling.src = ""
    document.querySelector(".popup-desc").style.display = 'none';
    document.querySelector(".popup-overlay-desc").style.display = 'none';
  }, false);
  
  document.querySelector(".popup-desc")?.addEventListener('click', function (e) {
    e.stopPropagation();
  }, false);
}